<template>
	<div class="layout zeta mb-">
		<template v-if="data.Type == 'subtitel'">
			<div class="layout__item u-1/1 u-text-align--center">
				<h6>{{ data.Text }}</h6>
			</div>
		</template>
		<template v-else>
			<div
				v-if="!(data.Type && data.Type === 'pdflink')"
				class="layout__item u-8/24-default u-1/1-palm"
				:class="sharedClass + ' ' + keyClass"
			>
				<h6>{{ data.Text }}</h6>
			</div>

			<div
				v-if="data.Value"
				class="layout__item u-16/24-default u-1/1-palm u-text--bold zeta"
				:class="sharedClass + ' ' + valueClass"
			>
				<template v-if="data.Type && data.Type === 'pdflink'">
					<a target="_blank" :href="data.Value" class="u-text-decoration--underline">{{ data.Text }}</a>
				</template>
				<template v-else><span v-html="data.Value"></span></template>
				<template v-if="data.Unit">&nbsp;{{ data.Unit }}</template>
			</div>
			<div class="layout__item u-1/1 u-text-color-grey" v-if="data.ToolTip">
				<p>{{ data.ToolTip }}</p>
			</div>
		</template>
	</div>
</template>

<script>
export default {
	props: {
		data: Object,
		sharedClass: {
			type: String,
			default: ''
		},
		keyClass: {
			type: String,
			default: ''
		},
		valueClass: {
			type: String,
			default: ''
		}
	}
};
</script>

<style></style>
